import { object, string } from 'yup';

export const validationSchema = object({
  code: string().required('Please fill in the confirmation code'),
});
